import { v4 as uuidv4 } from 'uuid';
import store from "@/store/index";
import request from "sync-request";
import JwtService from "@/core/services/JwtService";
import useClipboard from 'vue-clipboard3'
import XLSX from "xlsx-js-style";
import {Mutations} from "@/store/enums/StoreEnums";
import router from "@/router/index";
import markdownit from 'markdown-it'
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';
import {directPath} from "@/core/data/ConstData";
import { ElLoading, ElMessage } from 'element-plus';

import {marked} from "marked";
import htmlDocx from 'html-docx-js/dist/html-docx';
import { saveAs } from 'file-saver';

const UUID_KEY = "zhi-uuid";

export const checkAndGenerateUuid = () => {
    let uuid = window.localStorage.getItem(UUID_KEY);
    if(!uuid){
        uuid = uuidv4().replaceAll('-','');
        window.localStorage.setItem(UUID_KEY, uuid);
    }
};
export const getUuid = () => {
    let uuid = window.localStorage.getItem(UUID_KEY);
    if(!uuid){
        uuid = uuidv4().replaceAll('-','');
        window.localStorage.setItem(UUID_KEY, uuid);
    }
    return uuid;
};
export const authVerify = () => {
    let result = true;

    let res = request('POST', process.env.VUE_APP_API_URL+'/api/auth/verify', {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': JwtService.getToken(),
            'zhi-uuid': getUuid()
        },
    });
    if(res.statusCode == 401){
        result = false;
    }else{
        window.ZHI_TOKEN = JwtService.getToken();
    }
    return result;
}
export const initAccountInfo = () => {
    let res = request('POST', process.env.VUE_APP_API_URL+'/api/account/info', {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': JwtService.getToken(),
            'zhi-uuid': getUuid()
        },
    });
    if(res && res['statusCode'] == 200){
        let data = JSON.parse(res.getBody('utf8'));
        if(data['flag'] && data['flag'] == 'yes'){
            if(data['menu']){
                store.commit(Mutations.SET_ACCOUNT_MENU, data);
            }
        }
    }
}
export const saveAccountInfo = (accountInfo) => {
    window.localStorage.setItem('account_info', JSON.stringify(accountInfo));
}
export const getAccountInfo = () => {
    let accountInfo = window.localStorage.getItem('account_info');
    return accountInfo ? JSON.parse(accountInfo) : {
        name: '',
        nickname: ''
    };
}
export const destroyAccountInfo = () => {
    window.localStorage.removeItem('account_info');
}


const { toClipboard } = useClipboard()
export const copy = async(text) => {
    try {
        await toClipboard(text);
    } catch (e) {
        console.error(e)
    }
}
export const downloadImage = (imageSrc, name) => {
    let image = new Image()  //创建图片对象
    image.setAttribute('crossOrigin', 'anonymous') //设置允许跨域
    image.src = imageSrc+"?"+Date.now() //赋值src
    image.onload = () => {
        //等待图片加载完成创建canvas
        let canvas = document.createElement('canvas')
        //将图片绘制到canvas画布上
        canvas.width = image.width
        canvas.height = image.height
        let ctx = canvas.getContext('2d')
        ctx.drawImage(image, 0, 0, image.width, image.height)
        //获取图片文件格式  jpg/jpeg/png
        let ext = image.src.substring(image.src.lastIndexOf('.')+1).toLowerCase()
        //导出画布快照  此时已越过跨域限制成功取到图片数据
        let dataURL = canvas.toDataURL('image/' + ext)
        //创建a标签
        const a = document.createElement("a");
        // 赋值a标签download属性值，标明该a标签提供下载功能，同时该属性指定了下载时的文件名称
        a.download = name;
        //赋值a标签下载地址，即canvas导出的画布快照 base64格式的图片地址
        a.href = dataURL;
        //添加a标签到dom中
        document.body.appendChild(a);
        //触发a标签点击事件 触发下载
        a.click();
        //下载完成 删除多余的a标签  保持页面原有元素不动
        document.body.removeChild(a);
    }
}
export const previewImage = (src) => {
    previewImageList([src]);
}
export const previewImageList = (srcList) => {
    let proxy = window.vueApp['_instance']['proxy'];
    proxy.$viewerApi({
        options: {
            toolbar: true,
            title: false,
            tooltip: false
        },
        images: srcList
    });
}
export const inputDigital = (item) => {
    item = item.replace(/^(0+)|[^\d]+/g,'');
    return item;
}
export const inputRange = (item, min, max) => {
    let t = Number(item);
    if(t < min){
        t = min;
    }
    if(t > max){
        t = max;
    }
    return t;
}
export const exportExcel = (excelData) => {
    let headers = excelData.headers;
    let rows = excelData.rows;
    let sheetName = excelData['sheetName'] ? excelData['sheetName'] : '默认表单';
    let fileName = excelData['fileName'] ? excelData['fileName'] : '默认文件名';

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    /* fix headers */
    XLSX.utils.sheet_add_aoa(worksheet, [headers.map((item) => { return item.name })], { origin: "A1" });

    worksheet["!cols"] = headers.map((item) => { return { wch : item.width}; });
    for(let i=0;i<headers.length;i++){
        let cell = XLSX.utils.encode_col(i)+1;
        worksheet[cell].s = {
            font: {
                sz: 10,
                bold: true,
                color: { rgb: "434343" },
            },
            fill: {
                fgColor: { rgb: "8DB4E2" }
            }
        };
    }
    for(let i=0;i<headers.length;i++){
        for(let j=0;j<rows.length;j++){
            let cell = XLSX.utils.encode_col(i)+(j+2);
            worksheet[cell].s = {
                font: {
                    sz: 10,
                    color: { rgb: "333333" },
                },
                alignment:{
                    vertical: true,
                    wrapText: true
                }
            };
        }
    }


    /* calculate column width */
    // const max_width = rows.reduce((w, r) => Math.max(w, r.name.length), 10);
    // worksheet["!cols"] = [ { wch: max_width } ];

    /* create an XLSX file and try to save to Presidents.xlsx */
    XLSX.writeFile(workbook, fileName+".xlsx");
}

let blockLoading = null;
export const blockPage = (text='处理中，请稍等...') => {
    blockLoading = ElLoading.service({
        lock: true,
        text: text,
        background: 'rgba(0, 0, 0, 0.7)',
    })
}
export const unblockPage = () => {
    blockLoading ? blockLoading.close(): null;
}

export const navToPage = (path) => {
    if(path){
        router.push({
            path: path
        })
    }
}
export const downloadFile = (url, name) => {
    let anchor = document.createElement("a");
    document.body.appendChild(anchor);
    let file = url;
    let headers = new Headers();
    headers.append('Authorization', JwtService.getToken());
    headers.append('Zhi-UUID', getUuid());
    fetch(file, { headers })
        .then(response => response.blob())
        .then(blobby => {
            let objectUrl = window.URL.createObjectURL(blobby);
            anchor.href = objectUrl;
            anchor.download = name;
            anchor.click();
            window.URL.revokeObjectURL(objectUrl);
        });
}
export function randomString(length) {
    let str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = [];
    for (let i = length; i > 0; --i)
        result.push(str[Math.floor(Math.random() * str.length)]);
    return result.join('');
}

const mdi =  markdownit({
    breaks: true,
    highlight: function (str, lang) {
        if (lang && hljs.getLanguage(lang)) {
            try {
                const highlighted = hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
                    return `<pre class="relative m-0 p-0 leading-none text-[0]">
                            <code class="hljs zhi-scroll-horizontal break-all !p-2 sm:!p-4">${highlighted}</code>
                            <i class="far fa-copy absolute top-1 right-1 cursor-pointer text-sm md-copy-btn" data-code="${encodeURIComponent(str)}"></i>
                        </pre>`;
            } catch (__) {}
        }

        return `<pre class="relative m-0 p-0 leading-none text-[0]">
                <code class="hljs zhi-scroll-horizontal break-all !p-2 sm:!p-4">${mdi.utils.escapeHtml(str)}</code>
                <i class="far fa-copy absolute top-2 right-1 cursor-pointer text-sm md-copy-btn" data-code="${encodeURIComponent(str)}"></i>
            </pre>`;
    }
});
export const getMdiText = (text) => {
    let output = '';
    let inThinkMode = false;
    let currentIndex = 0;

    while (currentIndex < text.length) {
        let startIndex = text.indexOf('<think>', currentIndex);
        let endIndex = text.indexOf('</think>', currentIndex);

        if (startIndex === -1 && endIndex === -1) {
            // 没有 <think> 或 </think>，根据当前模式渲染剩余内容
            const remainingContent = text.substring(currentIndex);
            output += inThinkMode ? renderAsQuote(remainingContent) : mdi.render(remainingContent);
            break;
        }

        if (startIndex !== -1 && (endIndex === -1 || startIndex < endIndex)) {
            // 找到 <think>
            const normalContent = text.substring(currentIndex, startIndex);
            output += inThinkMode ? renderAsQuote(normalContent) : mdi.render(normalContent);
            output += mdi.render(""); // 空格或者换行
            inThinkMode = true;
            currentIndex = startIndex + '<think>'.length;
        } else if (endIndex !== -1) {
            // 找到 </think>
            const quoteContent = text.substring(currentIndex, endIndex);
            output += renderAsQuote(quoteContent);
            output += mdi.render(""); // 空格或者换行
            inThinkMode = false;
            currentIndex = endIndex + '</think>'.length;
        }
    }

    return output;

    function renderAsQuote(text) {
        const quote = text.split('\n').map(line => '> ' + line).join('\n');
        return mdi.render(quote);
    }
    // return mdi.render(text)
}
export const initMarkdownCopy = () => {
    setTimeout(() => {
        const copyButtons = document.querySelectorAll('.markdown-it .md-copy-btn');
        copyButtons.forEach(button => {
            if(!button.dataset.clickBound){
                button.addEventListener('click', (event) => {
                    const button = event.target;
                    if (!button) {
                    return; // 确保点击事件来自按钮
                    }
                    const code = decodeURIComponent(button.getAttribute('data-code'));
                    ElMessage.success('复制成功');
                    copy(code);
                });
                button.dataset.clickBound = 'true'
            }
        });
    },100)
}

export const showNormalSeconds = (seconds) => {
    const days = Math.floor(seconds / (60 * 60 * 24));
    const hours = Math.floor((seconds % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((seconds % (60 * 60)) / 60);
    const remainingSeconds = seconds % 60;
    let formattedTime = '';
    if (days > 0) {
        formattedTime += `${days}天`;
    }
    if (hours > 0) {
        formattedTime += `${hours}小时`;
    }
    if (minutes > 0) {
        formattedTime += `${minutes}分`;
    }
    if (remainingSeconds > 0 || formattedTime === '') {
        formattedTime += `${remainingSeconds}秒`;
    }
    return formattedTime;
}

export const checkDirectAccess = (path) => {
    return (directPath.includes(path) || path.startsWith('/help/xhs/auth')) ? true : false;
}
export const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
export const getRootFontSize = () => {
    return parseFloat(getComputedStyle(document.documentElement).fontSize)
}

export const downloadWordFromMarkdown = (md_text, file_name) => {
    const renderer = new marked.Renderer();
    renderer.image = (href, title, text) => {
        const imageWidthInWord = 550;
        return `<img src="${href}" alt="${text}" title="${title || ''}" width="${imageWidthInWord}">`;
    };

    // 使用自定义渲染器将Markdown转换为HTML
    const htmlContent = marked(md_text, { renderer: renderer });

    // --- 关键优化 2: 提供一套为Word优化的CSS样式 ---
    const styledHtml = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <title>Document</title>
      <style>
        body { font-family: 'Times New Roman', '宋体', serif; font-size: 12pt; }
        h1, h2, h3, h4, h5, h6 { font-family: 'Arial', '黑体', sans-serif; color: #000000; font-weight: bold; }
        h1 { font-size: 22pt; margin-top: 24pt; margin-bottom: 16pt; }
        h2 { font-size: 16pt; margin-top: 18pt; margin-bottom: 12pt; }
        h3 { font-size: 14pt; margin-top: 14pt; margin-bottom: 10pt; }
        p { margin-bottom: 10pt; line-height: 1.5; text-align: justify; }
        table { border-collapse: collapse; width: 100%; margin-bottom: 10pt; }
        th, td { border: 1px solid #000000; padding: 5pt; text-align: left; }
        th { background-color: #f2f2f2; font-weight: bold; text-align: center; }
        pre { background-color: #f5f5f5; padding: 10pt; border: 1px solid #cccccc; font-family: 'Courier New', monospace; white-space: pre-wrap; word-wrap: break-word; }
        code { font-family: 'Courier New', monospace; }
        
        /* --- 关键修正：分级控制列表缩进 --- */
        ul, ol {
          padding-left: 22pt; /* 为第一级列表设置标准缩进 */
          margin-left: 0;
        }
        li ul, li ol {
          padding-left: 16pt; /* 为所有嵌套列表（二级及以上）设置更小的缩进值 */
        }

        a { color: #0563c1; text-decoration: underline; }
      </style>
    </head>
    <body>
      ${htmlContent}
    </body>
    </html>
  `;

    const docxBlob = htmlDocx.asBlob(styledHtml);
    saveAs(docxBlob, `${file_name}.docx`);
}

export default {
    checkAndGenerateUuid,
    getUuid,
    authVerify,
    initAccountInfo,
    saveAccountInfo,
    getAccountInfo,
    destroyAccountInfo,
    copy,
    downloadImage,
    previewImage,
    previewImageList,
    inputDigital,
    inputRange,
    exportExcel,
    blockPage,
    unblockPage,
    navToPage,
    downloadFile,
    randomString,
    getMdiText,
    showNormalSeconds,
    checkDirectAccess,
    isMobile,
    getRootFontSize,
    initMarkdownCopy,
    downloadWordFromMarkdown
};
